/* eslint-disable jsx-a11y/no-distracting-elements */
import React, { useState, useEffect, useMemo } from "react";
import { Button } from "react-bootstrap";

const interactions = [
  {
    title: "Appointment Booking",
  },
  {
    title: "Book an Order",
  },
  {
    title: "General Inquiries",
  },
];

const AudioCall = () => {
  const [playingIndex, setPlayingIndex] = useState(null);
  const [transcript, setTranscript] = useState("");

  const audioRefs = useMemo(
    () => ({
      0: { current: new Audio("/assets/appointment_booking.mp3") },
      1: { current: new Audio("/assets/book_an_order.mp3") },
      2: { current: new Audio("/assets/general_inquiries.mp3") },
    }),
    []
  );

  const transcriptData = useMemo(
    () => ({
      0: `
            Hello, I'm Nouraa, the practice's AI assistant. How may I help you today? 
            Hey, I want to book an appointment. 
            Great. May I have your name, please? 
            Yeah, it's Sarah Tucker. 
            Thank you, Sarah. Have you visited us before, or is this your first time? 
            This is going to be my first time. 
            Got it. Could you please provide your birth date? This helps us set up your profile. 
            Sure. It's 5 October, 1986.

            Thank you, Sarah. What is the reason for your appointment? Are you looking for a routine checkup or specialized care? 
            Just a routine checkup, please.  
            All right. Let me check the next available slots for a routine checkup. 
            Could you please tell me your preferred date and time range? For example, a date and time during the day or evening that works best for you. 
            Do you have anything in the morning? 
            Yes. Let me find the available slots for you in the morning. Please hold on a moment.

            Here are some available morning slots on April 10th.  
            8 a.m.,  8:30 a.m.,  9 a.m.,  9:30 a.m., 10 a.m., 10:30 a.m.,  11 a.m. 
            Do any of these times work for you?  
            11 a.m. works for me. 
            Great choice. Let's confirm your details. Your appointment will be on April 10th at 11 a.m. 
            Could you please provide your email address so I can finalize the booking?  
            Sure.  SARAH at example dot com.

           Thank you, Sarah. Just to confirm, your email address is  SARAH at example.com, correct?  
            Yes.

            Your appointment is successfully booked for April 10th at 11 a.m. 
            Thank you, Sarah, and we look forward to seeing you. Have a great day. 
            Thank you. You're welcome.  
            If you have any more questions or need further assistance, feel free to ask. Have a wonderful day.
    `,
      1: `
      Hello, you've reached Pizza Kings. I'm a digital assistant to help you with your online orders. How may I assist you today? 
      Hey, I want to order a pizza. 
      Great. I'd be happy to take your pizza order. What size and type of pizza would you like? 
      Can I have two Chicken Supreme pizzas? 
      Absolutely. Would you like those Chicken Supreme pizzas in a small? 
      Medium or large size? Both and large. 
      Got it. Two large Chicken Supreme pizzas. Would you like to add any drinks to your order? 
      Yeah, add two Diet Cokes. 
      Perfect. So your order is two large Chicken Supreme pizzas and two cans of Diet Coke. Let me calculate your total. 
      The two large Chicken Supreme pizzas are $22 each and the two Diet Cokes are $2 each. So the total comes to $48. Would you
      like to proceed with this order? Yes. Great. To confirm, your order of two large Chicken Supreme pizzas and two cans of Diet Coke
      will be ready for you. Thank you for your order with Pizza Kings. Would you like to add anything else? No, thank you so much. You're
      welcome. Your order is all set. We'll have it ready for you soon.
    `,
      2: `
         Hello, I'm Nouraa, the practice's AI assistant. How may I help you today? 
        Hey, I want to know, is your clinic open on Sundays? 
        I'm sorry, but our clinic is closed on Sundays. Our opening hours are Monday to Thursday from 9.30 a.m. to 5.30 p.m. CST 
        and Friday to Saturday from 11 a.m. to 4.30 p.m. CST. Would you like to know anything else? 
        Oh, yes. Is there any parking lot available nearby? 
        Yes, there is parking available nearby the clinic. You should find it quite convenient. Would you like to know anything else? 
        Yeah, I want to know if your clinic has a wheelchair accessible entrance? 
        Yes, the clinic has a wheelchair accessible entrance. We want to ensure everyone has easy access. Is there anything else I can help you with? 
        Yeah, please tell me about your waiting room facility. 
         Our waiting room is quite comfortable. It includes a small play area for kids and you'll find magazines and newspapers to read while you wait. 
        If there is anything else you'd like to know? No, that's it. Thank you so much. 
        You're welcome. Thank you for calling and have a great day.
        Yeah, please tell me about your waiting room facility.
        our waiting room is quite comfortable. includes a small play area for kids
        and you'll find magazines and newspapers to read while you wait. If there
        anything else you'd like to know? No, that's it. Thank you so much.
        You're welcome. Thank you for calling and have a great day.
      `,
    }),
    []
  );

  useEffect(() => {
    if (playingIndex !== null) {
      setTranscript(transcriptData[playingIndex]);
    } else {
      setTranscript("");
    }
  }, [playingIndex, transcriptData]);

  useEffect(() => {
    const handlePageNavigation = () => {
      if (playingIndex !== null) {
        audioRefs[playingIndex]?.current.pause();
        setPlayingIndex(null);
        setTranscript("");
      }
    };

    window.addEventListener("beforeunload", handlePageNavigation);
    window.addEventListener("popstate", handlePageNavigation);

    return () => {
      handlePageNavigation(); // Ensure audio stops on component unmount
      window.removeEventListener("beforeunload", handlePageNavigation);
      window.removeEventListener("popstate", handlePageNavigation);
    };
  }, [playingIndex, audioRefs]); // Added 'audioRefs' to the dependency array

  const handlePlayPauseClick = (index) => {
    const currentAudio = audioRefs[index]?.current;
    if (currentAudio) {
      if (playingIndex === index) {
        currentAudio.pause();
        setPlayingIndex(null);
      } else {
        if (playingIndex !== null) {
          audioRefs[playingIndex]?.current.pause();
        }
        currentAudio.play();
        setPlayingIndex(index);
      }
    }
  };

  const handleCallClick = () => {
    const phoneNumber = "+14422497877";
    if (/Mobi|Android/i.test(navigator.userAgent)) {
      // Mobile view: directly open the calling section
      window.location.href = `tel:${phoneNumber}`;
    } else {
      // Desktop view: show call options
      const callOptions = `tel:${phoneNumber}`;
      window.location.href = callOptions;
    }
  };

  return (
    <div className="text-center empty-space-mt">
      <h2 className="fw-bold fs-four-title anybody-font w-50 mx-auto text-break">
        Hear Nouraa in Action: Real Customer Interactions
      </h2>
      <p className="gray-color fs-two my-5">
        AI That Listens, Understands, and Responds with Care
      </p>

      <div className="d-flex justify-content-center flex-wrap gap-4 my-5">
        {interactions.map((item, index) => (
          <div
            key={index}
            className="d-flex justify-content-around align-items-center p-3 col-lg-3 border-color rounded-4 px-0 position-relative"
          >
            <div>
              <img
                src="/assets/Ellipse_3.png"
                alt={item.title}
                className="img-fluid me-3"
              />
              <span className="fw-bold anybody-font">
                {playingIndex === index ? (
                  <marquee className="transcript-marquee fw-medium w-75 align-content-around">
                    {transcript}
                  </marquee>
                ) : (
                  item.title
                )}
              </span>
            </div>
            <button
              className="border-0 bg-white"
              onClick={() => handlePlayPauseClick(index)}
            >
              <img
                src={
                  playingIndex === index
                    ? "/assets/pause.svg"
                    : "/assets/play.svg"
                }
                alt={playingIndex === index ? "Pause" : "Play"}
              />
            </button>
          </div>
        ))}
      </div>
      <div className="empty-space-my d-flex align-items-center justify-content-evenly flex-wrap">
        <h3 className="fw-bold fs-four-title anybody-font ms-lg-5">
          Call Now to See AI in Action
        </h3>

        <Button
          variant="none"
          className="call-button d-flex align-items-center fw-bold me-lg-5"
          onClick={handleCallClick}
        >
          <div className="call-icon me-3">
            <img
              src="/assets/phone-white.svg"
              alt="Call"
              className="align-baseline"
            />
          </div>
          +1 (442) 249-7877
        </Button>
      </div>
    </div>
  );
};

export default AudioCall;
